import ActiveModelAdapter from './active-model-adapter';
import ActiveModelSerializer from './active-model-serializer';
export default ActiveModelAdapter;
export { ActiveModelAdapter, ActiveModelSerializer };